import { Link, Typography } from '@mui/material';
import {
  getFormattedRuPhone,
  getFullName as getClientFullName,
} from 'core/utils/commonUtils';
import { isEmpty, isNil } from 'lodash';
import type { Client } from 'models/client/client';
import type { SyntheticEvent } from 'react';

const ClientCell = ({ data }: ClientCellProps): JSX.Element => {
  const contactsClickHandle = (e: SyntheticEvent): void => {
    e.stopPropagation();
  };

  return (
    <>
      <Typography>{!isNil(data) && getClientFullName(data)}</Typography>

      {!isEmpty(data?.phone) && (
        <Link
          variant='caption'
          onClick={contactsClickHandle}
          href={`tel:+${data?.phone}`}>
          {getFormattedRuPhone(data?.phone)}
        </Link>
      )}
    </>
  );
};

export interface ClientCellProps {
  data: Client;
}

export default ClientCell;
